/**
 * Route for `automated-invoice-generation-publisher-advertiser`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AutomatedInvoiceGenerationPublisherAdvertiserPage } from "../features/automated-invoice-generation-publisher-advertiser/AutomatedInvoiceGenerationPublisherAdvertiserPage";

export const automatedInvoiceGenerationPublisherAdvertiserRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/automated-invoice-generation-publisher-advertiser",
	component: AutomatedInvoiceGenerationPublisherAdvertiserPage,
});

export default automatedInvoiceGenerationPublisherAdvertiserRoute;
